import Axios from "@/plugins/Axios";

export class SemestresService {
  async syncAll() {
    const response = await Axios().get("semestres");
    return response.data;
  }
}

export default new SemestresService();
